"use strict";

$.widget("fotobook.shadowColorWidget", $.fotobook.baseColorWidget, {
    "options" : {
        "alpha" : false,
        "disabledClass" : "disabled",
        "isTextContainer": false,
        "element": {},
    },

    _create: function(){
        this.options.isTextContainer = Number(this.options.container.attr('data-container-type')) === Fotobook.ContainerType.CAPTION;
        this.options.$element = this.options.isTextContainer ? this._getColorSourceTextElement() : this._getColorSourceElement();
        this._super();
    },
    _colorPickerSetColor: function(color){
        this._setPreviewStyle(color);
    },
    _colorPickerCancel: function(){
        this._removePreviewStyle();
    },
    _colorPickerOk: function(color){
        Fotobook.containers.changeContainerAttrs({
            [this.getContainerId()] : {
                "drop_shadow": {
                    "color": (new WebColor(color)).get_hex(),
                }
            },
        }).catch(
            () => {}
        ).finally(() => {
            this._removePreviewStyle();
        });
    },
    _getColorSourceElement: function(){
        return this.options.container.find(".apply-flood-color");
    },
    _getColorSourceTextElement: function(){
        return this.options.container.find(".text-content");
    },
    _removePreviewStyle: function(){
        this.options.$element.attr("flood-color", this.options.$element.attr("data-flood-color"));
    },
    _setPreviewStyle: function(color){
        if (!(color instanceof WebColor)){
            color = new WebColor(color);
        }
        this.options.$element.attr("flood-color", color.get_hex());
    },
    _setOptionDisabled: function(value){
        this.element.css("pointer-events", value ? "none" : "");
        this._super(value);
    },
    _checkEnabled: function(){
        const isTextShadowInit = this.options.$element.css('text-shadow') === "none";
        return (this.options.isTextContainer && !isTextShadowInit) || !!this._getColorSourceElement().length;
    },
    _getColorFromProject: function(){
        return new WebColor(this.options.$element.css('text-shadow')).get_smart();
    },
    _destroy: function(){
        this._removePreviewStyle();
        this._super();
    },
});
